import movieData from "./movies";
import tvShowData from "./tvshows";
import albumData from "./albums";

const data = [
  {
    label: "Movie",
    images: movieData
  },
  {
    label: "TV Show",
    images: tvShowData
  },
  {
    label: "Album",
    images: albumData
  }
];

export default data;
